import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ shape, custom, palette, breakpoints }: Theme) => ({
    wrapper: {
      marginTop: 20,
    },
    successWrapper: {
      borderRadius: shape.borderRadius,
      backgroundColor: '#e5f3eb',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      border: 'solid 2px #fff',
      padding: 20,
      marginBottom: 20,
    },
    successIcon: {
      marginBottom: 20,
      padding: 8,
      fontSize: 42,
      display: 'block',
      borderRadius: '100%',
      color: palette.common.white,
      backgroundColor: custom.green[1],
    },
    successTitle: {
      fontSize: 14,
      fontWeight: 800,
      textAlign: 'center',
    },
    creditInformationWrapper: {
      borderRadius: shape.borderRadius,
      backgroundColor: palette.background.default,
      padding: 20,
    },
    creditInformation: {
      fontSize: 14,
      fontWeight: 800,
      borderBottom: 'solid 1px rgba(202, 202, 202, 0.5)',
      paddingBottom: 15,
      marginBottom: 15,
      lineHeight: 1.43,
    },
    creditDetails: {
      display: 'flex',
      fontSize: 14,
      marginBottom: 10,
      flexWrap: 'wrap',
      [breakpoints.down(460)]: {
        gap: 0,
      },
      '& > div:first-of-type': {
        width: 235,
      },
      '& span': {
        lineHeight: 1.4,
        marginBottom: 5,
        display: 'block',
      },
    },
    documents: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    documentLink: {
      color: palette.primary.main,
      textDecoration: 'none',
      fontSize: 14,
      lineHeight: 1.4,
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      '&:first-of-type': {
        width: 235,
      },
      '&:hover': {
        '& > span': {
          textDecoration: 'underline',
        },
      },
      '& svg': {
        marginRight: 5,
      },
    },
    button: {
      marginTop: 45,
      fontSize: 16,
      lineHeight: 1.25,
      padding: '12.5px',
    },
  })
);
